"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vueAwesomeSwiper = require("vue-awesome-swiper");

var _SlideInstagramComponent = require("./slide-instagram/SlideInstagramComponent.vue");

var _SlideInstagramComponent2 = _interopRequireDefault(_SlideInstagramComponent);

var _SlideInfoComponent = require("./slide-info/SlideInfoComponent.vue");

var _SlideInfoComponent2 = _interopRequireDefault(_SlideInfoComponent);

var _momentTimezone = require("moment-timezone");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import posts from "../../data/posts"

exports.default = {

    props: ["dico", "currentFarm"],

    components: {

        SlideInstagram: _SlideInstagramComponent2.default,
        SlideInfo: _SlideInfoComponent2.default,
        swiper: _vueAwesomeSwiper.swiper,
        swiperSlide: _vueAwesomeSwiper.swiperSlide

    },

    computed: {

        slides: function slides() {
            var _this = this;

            var slides = [];
            _lodash2.default.each(this.currentFarm.instagramPosts, function (post) {
                var rowData = JSON.parse(post.raw_data);
                var lang = window.GLOBAL_CONFIG.lang;
                var timezone = _this.currentFarm.config.location.timezone ? _this.currentFarm.config.location.timezone : 'Europe/Paris';
                _momentTimezone2.default.locale(lang);

                /*
                switch ( lang ) {
                    case 'en' :
                        lang = 'en-gb';
                        break;
                }
                */
                //let dateMoment = moment(rowData.created_time * 1000).tz(timezone);
                var dateMoment = (0, _momentTimezone2.default)(post.created_at).tz(timezone);

                slides.push({
                    media: post.imageUrl, //TODO check fetch images
                    date: dateMoment,
                    description: _this.getDescription(post, lang)
                });
            });

            if (slides.length < 3) {
                _lodash2.default.each(this.currentFarm.config.instagram.fallback_images, function (image) {
                    if (image) {
                        slides.push({
                            media: window.GLOBAL_CONFIG.baseUploadUrl.replace('__path__', image),
                            date: "",
                            description: ""
                        });
                    }
                });
            }

            //slides = _.concat(posts[this.currentFarm.config.id], slides);

            // console.log(posts[this.currentFarm.config.id]);

            return slides;
        }
    },

    methods: {
        getDescription: function getDescription(post, lang) {
            var rowData = JSON.parse(post.raw_data);

            if (!_lodash2.default.isUndefined(post.locale_text) && post.locale_text) return post.locale_text;

            if (lang !== "en") return "";

            if (!_lodash2.default.isUndefined(post.text) && post.text) return post.text;

            if (!_lodash2.default.isUndefined(rowData.caption.text) && rowData.caption.text) return rowData.caption.text;

            return "";
        }
    },

    watch: {

        currentFarm: function currentFarm() {
            if (this.$refs.slider.swiper) this.$refs.slider.swiper.slideTo(0, 0);
        }

    },

    data: function data() {
        return {
            swiperOption: {
                slidesPerView: 3,
                nextButton: '.slider__nav__right',
                prevButton: '.slider__nav__left',
                autoplay: window.GLOBAL_CONFIG.isShop ? 15000 : "",
                loop: window.GLOBAL_CONFIG.isShop,
                spaceBetween: 5,
                breakpoints: {
                    768: {
                        slidesPerView: 1
                    }
                }
            }
        };
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?{"presets":["es2015","stage-0"],"plugins":["transform-class-properties","transform-function-bind"]}!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/slider/SliderComponent.vue
// module id = 402
// module chunks = 0